import React from 'react';
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';



import Formato_2319013 from '../media/img_on_amazon/FormatoSimplificado_2319013.pdf';
import Formato_2319037 from '../media/img_on_amazon/FormatoSimplificado_2319037.pdf';
import Formato_2319054 from '../media/img_on_amazon/FormatoSimplificado_2319054.pdf';
import Formato_2319058 from '../media/img_on_amazon/FormatoSimplificado_2319058.pdf';
import Formato_2319067 from '../media/img_on_amazon/FormatoSimplificado_2319067.pdf';
import Formato_2318686 from '../media/img_on_amazon/FormatoSimplificado_2318686.pdf';
import Formato_2318699 from '../media/img_on_amazon/FormatoSimplificado_2318699.pdf';
import Formato_2318712 from '../media/img_on_amazon/FormatoSimplificado_2318712.pdf';
import Formato_2318723 from '../media/img_on_amazon/FormatoSimplificado_2318723.pdf';
import Formato_2318735 from '../media/img_on_amazon/FormatoSimplificado_2318735.pdf';



import Formato_2318936 from '../media/img_on_amazon/FormatoSimplificado_2318936.pdf';
import Formato_2318947 from '../media/img_on_amazon/FormatoSimplificado_2318947.pdf';
import Formato_2318957 from '../media/img_on_amazon/FormatoSimplificado_2318957.pdf';
import Formato_2318967 from '../media/img_on_amazon/FormatoSimplificado_2318967.pdf';
import Formato_2318979 from '../media/img_on_amazon/FormatoSimplificado_2318979.pdf';
import Formato_2318833 from '../media/img_on_amazon/FormatoSimplificado_2318833.pdf';
import Formato_2318845 from '../media/img_on_amazon/FormatoSimplificado_2318845.pdf';
import Formato_2318860 from '../media/img_on_amazon/FormatoSimplificado_2318860.pdf';
import Formato_2318869 from '../media/img_on_amazon/FormatoSimplificado_2318869.pdf';
import Formato_2318880 from '../media/img_on_amazon/FormatoSimplificado_2318880.pdf';



import Formato_2318893 from '../media/img_on_amazon/FormatoSimplificado_2318893.pdf';
import Formato_2318987 from '../media/img_on_amazon/FormatoSimplificado_2318987.pdf';
import Formato_2318752 from '../media/img_on_amazon/FormatoSimplificado_2318752.pdf';
import Formato_2319081 from '../media/img_on_amazon/FormatoSimplificado_2319081.pdf';
import Formato_2370974 from '../media/img_on_amazon/FormatoSimplificado_2370974.pdf';
import Formato_2370975 from '../media/img_on_amazon/FormatoSimplificado_2370975.pdf';






const Rates = props =>
{
    return (
        <div id='rates' className='container p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h4 className='mb-4'>REGISTRO DE TARIFAS ANTE IFT</h4>

                <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO</th>
                        </tr>
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">Disponibles para venta nueva</th>
                        </tr>

                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 80 GB (sin renta de equipo)</td>
                            <td><a href={Formato_2319013} target='_blank' rel='noopener noreferrer'>2319013</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 100 GB (sin renta de equipo)</td>
                            <td><a href={Formato_2319037} target='_blank' rel='noopener noreferrer'>2319037</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 120 GB (sin renta de equipo)</td>
                            <td><a href={Formato_2319054} target='_blank' rel='noopener noreferrer'>2319054</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 150 GB (sin renta de equipo)</td>
                            <td><a href={Formato_2319058} target='_blank' rel='noopener noreferrer'>2319058</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 200 GB (sin renta de equipo)</td>
                            <td><a href={Formato_2319067} target='_blank' rel='noopener noreferrer'>2319067</a></td>
                        </tr>
{/*                         <tr>
                            <td>ON Internet Inalámbrico 20 con 180 GB (sin renta de equipo)</td>
                            <td><a href={Formato_1765082} target='_blank' rel='noopener noreferrer'>1765082</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 5 con 50 GB (con renta de equipo)</td>
                            <td><a href={Formato_1038573} target='_blank' rel='noopener noreferrer'>1038573</a></td>
                        </tr> */}
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 80 GB (con renta de equipo)</td>
                            <td><a href={Formato_2318686} target='_blank' rel='noopener noreferrer'>2318686</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 100 GB (con renta de equipo)</td>
                            <td><a href={Formato_2318699} target='_blank' rel='noopener noreferrer'>2318699</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 120 GB (con renta de equipo)</td>
                            <td><a href={Formato_2318712} target='_blank' rel='noopener noreferrer'>2318712</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 150 GB (con renta de equipo)</td>
                            <td><a href={Formato_2318723} target='_blank' rel='noopener noreferrer'>2318723</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 200 GB (con renta de equipo)</td>
                            <td><a href={Formato_2318735} target='_blank' rel='noopener noreferrer'>2318735</a></td>
                        </tr>
               
                        <tr>
                            <td className='td-title' colSpan='2'>Paquetes GB adicionales que aplican para todos los paquetes</td>
                        </tr>
                        <tr>
                            <td>Paquete adicional 5 GB Inalámbrico</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/157323024420385gb.pdf' target='_blank' rel='noopener noreferrer'>254776</a></td>
                        </tr> 
                        
                    </tbody>
                </table>                



                   <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO FRANJA FRONTERIZA</th>
                        </tr>


                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Internet Inalámbrico 5 con 80 GB Zona Fronteriza (sin renta de equipo)</td>
                            <td><a href={Formato_2318936} target='_blank' rel='noopener noreferrer'>2318936</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 5 con 100 GB Zona Fronteriza (sin renta de equipo)</td>
                            <td><a href={Formato_2318947} target='_blank' rel='noopener noreferrer'>2318947</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 10 con 120 GB Zona Fronteriza (sin renta de equipo)</td>
                            <td><a href={Formato_2318957} target='_blank' rel='noopener noreferrer'>2318957</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 150 GB Zona Fronteriza (sin renta de equipo)</td>
                            <td><a href={Formato_2318967} target='_blank' rel='noopener noreferrer'>2318967</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 200 GB Zona Fronteriza (sin renta de equipo)</td>
                            <td><a href={Formato_2318979} target='_blank' rel='noopener noreferrer'>2318979</a></td>
                        </tr>
{/*                         <tr>
                            <td>ON Internet Inalámbrico 20 con 180 GB Zona Fronteriza (sin renta de equipo)</td>
                            <td><a href={Formato_1763562} target='_blank' rel='noopener noreferrer'>1763562</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 5 con 50 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_1040197} target='_blank' rel='noopener noreferrer'>1040197</a></td>
                        </tr> */}
                         <tr>
                            <td>ON Internet Inalámbrico 5 con 80 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_2318833} target='_blank' rel='noopener noreferrer'>2318833</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 5 con 100 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_2318845} target='_blank' rel='noopener noreferrer'>2318845</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 10 con 120 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_2318860} target='_blank' rel='noopener noreferrer'>2318860</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 150 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_2318869} target='_blank' rel='noopener noreferrer'>2318869</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 10 con 200 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_2318880} target='_blank' rel='noopener noreferrer'>2318880</a></td>
                        </tr>
                       
                       
                        <tr>
                            <td className='td-title' colSpan='2'>Paquetes GB adicionales que aplican para todos los paquetes</td>
                        </tr>
                        <tr>
                            <td>Paquete adicional 5 GB Inalámbrico</td>
                            <td><a href='https://tarifas.ift.org.mx/ift_visor/assets/ratefiles/15868235699810paqueteadicional.pdf' target='_blank' rel='noopener noreferrer'>298600</a></td>
                        </tr>
                        
                       
                      
                    </tbody>
                </table>






                   <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">NO disponibles para venta nueva </th>
                        </tr>
                          <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO  </th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                            <td>ON Internet Inalámbrico 20 con 180 GB (con renta de equipo)</td>
                            <td><a href={Formato_2318752} target='_blank' rel='noopener noreferrer'>2318752</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 20 con 180 GB (sin renta de equipo)</td>
                            <td><a href={Formato_2319081} target='_blank' rel='noopener noreferrer'>2319081</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 50 GB (con renta de equipo)</td>
                            <td><a href={Formato_2370974} target='_blank' rel='noopener noreferrer'>2370974</a></td>
                        </tr>
                       {/*<tr>
                            <td>ON Inalámbrico Internet 20 sin renta de equipo</td>
                            <td><a href={Formato_1654334} target='_blank' rel='noopener noreferrer'>1654334</a></td>
                        </tr>*/}
                       
                    </tbody>
                </table>


                     <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>

                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">NO disponibles para venta nueva </th>
                        </tr>
                          <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON INALÁMBRICO PLANES POSTPAGO FRANJA FRONTERIZA </th>
                        </tr>
                        <tr>
                            <th>NOMBRE</th>
                            <th>TARIFA</th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <td>ON Internet Inalámbrico 20 con 180 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_2318893} target='_blank' rel='noopener noreferrer'>2318893</a></td>
                        </tr>
                         <tr>
                            <td>ON Internet Inalámbrico 20 con 180 GB Zona Fronteriza (sin renta de equipo)</td>
                            <td><a href={Formato_2318987} target='_blank' rel='noopener noreferrer'>2318987</a></td>
                        </tr>
                        <tr>
                            <td>ON Internet Inalámbrico 5 con 50 GB (con renta de equipo) Franja Fronteriza</td>
                            <td><a href={Formato_2370975} target='_blank' rel='noopener noreferrer'>2370975</a></td>
                        </tr>
                        {/* <tr>
                            <td>ON Inalámbrico Internet 20 sin renta de equipo</td>
                            <td><a href={Formato_1654386} target='_blank' rel='noopener noreferrer'>1654386</a></td>
                        </tr>*/}
                       
                    </tbody>
                </table>




                <p>Las tarifas ante señaladas pueden consultarse en el Registro Público de Concesiones, publicado en la página electrónica del Instituto Federal de Telecomunicaciones</p>
            </TocPage>
        </div>
    );
}

export default Rates;



// WEBPACK FOOTER //
// ./src/components/Rates_in.js